import { render, staticRenderFns } from "./videoControls.vue?vue&type=template&id=4f4549fd"
import script from "./videoControls.vue?vue&type=script&lang=js"
export * from "./videoControls.vue?vue&type=script&lang=js"
import style0 from "./videoControls.vue?vue&type=style&index=0&id=4f4549fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports